export const STORE_FETCH = '[Store] Store Fetch'
export const STORE_FETCH_SUCCESS = '[Store] Store Fetch Success'
export const STORE_FETCH_ERROR = '[Store] Store Fetch Error'
export const fetchStores = () => ({ type: STORE_FETCH })

export const SET_ACTIVE_STORE = '[Store] Set Active Store'
export const setActiveStore = store => ({ type: SET_ACTIVE_STORE, payload: store })